// All admin REST traffic now flows through the single API Gateway
// (see src/config/index.js). The old FIREBLOCK_URL / ORDER_URL splits
// are gone — every path below is relative to `request`'s baseURL.
import { encryptResponse } from "../config/validation";
import request from "./request";

// auth
export const login = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post("/admin/auth/login", data)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e.response);
      });
  });
};

export const verifyLoginOtp = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post("/admin/auth/verify-login-otp", data)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e.response);
      });
  });
};

export const resendLoginOtp = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post("/admin/auth/resend-login-otp", data)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e.response);
      });
  });
};

// TODO(monorepo-migration): the legacy non-prefixed /auth/* admin flows
// below (resendOtp, verifyOtp, loginVerifyEmail, forgotPassword, sendMail,
// verifyMail, setPassword) are not exposed by the new admin-service —
// admin-service only has /admin/auth/{login,register,logout,password,csrf-token}.
// These calls will 404 until either the backend adds equivalents or the
// callers are repointed at /user/auth/*. Leaving paths unchanged to make
// the gap obvious during testing.
export const resendOtp = (data) => {
  console.log(data);
  return new Promise(async (resolve, reject) => {
    await request
      .patch("auth/resend/email", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const verifyOtp = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put("auth/verifyEmail", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const loginVerifyEmail = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch("auth/send-otp", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const forgotPassword = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put("auth/forgot/password", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const sendMail = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put("auth/send/email", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const verifyMail = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put("auth/verify/email", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const setPassword = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put("auth/forgot/password", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// user
export const getUser = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/users`, { params })
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getUserById = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/users/${id}`)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};
// Returns Fireblocks vault account + deposit addresses per chain
export const getUserFireblocksWallet = (userId) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/user-wallet/trx/${userId}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// All of a user's FUNDING wallet docs (one per coin they've ever held), no
// zero-balance filtering — used by the Manual Wallet Adjustment tab to look
// up "current balance" for a selected coin, including coins the user has
// zero/no wallet doc for yet (absent from the array = 0).
export const getUserFundingWalletsApi = (userId) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/user-wallet/trx/${userId}`)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e?.response || e));
  });
};

// Returns FUNDING or SPOT wallet balances per coin for a user
// walletType: "FUNDING" | "SPOT"
// TODO(monorepo-migration): /admin/wallet is not defined in the new
// admin-service. For SPOT use /admin/users/:userId/spot-balance; for FUNDING
// per-coin use /admin/user-wallet/trx/:id. Repoint callers and remove this.
export const getUserWalletByType = (userId, walletType) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/wallet`, { params: { userId, walletType } })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// /admin/user/:id/third-party stays singular — see admin-service routes.
export const getUserThirdPartyData = (userId) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/user/${userId}/third-party`)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// TODO(monorepo-migration): /admin/user/search-list has no direct replacement.
// `/admin/users` accepts a search query — consider switching callers to use it.
export const getUsersSearch = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/user/search-list`, { params })
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};
// TODO(monorepo-migration): /admin/addUser is not defined in the new
// admin-service. Backend equivalent is missing; remove this caller or wait
// for the backend to expose a replacement.
export const addUser = (body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/addUser`, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
// TODO(monorepo-migration): generic PUT /admin/users/:id is not defined in
// the new admin-service. Per-field actions (lock, freeze, kyc, bank, etc.)
// each have their own endpoint. Verify callers and split into those.
export const editUser = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`admin/users/` + id, body)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const updatePassword = (body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`admin/auth/password`, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
// TODO(monorepo-migration): /admin/user/profile/:id is not defined in the
// new admin-service. Verify callers — likely dead code.
export const updateProfile = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`admin/user/profile/` + id, body)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const deleteUser = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`admin/users/` + id)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const reactivateUser = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch(`admin/users/${id}/reactivate`)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const deactivateUser = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch(`admin/users/${id}/deactivate`)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const activateUser = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch(`admin/users/${id}/activate`)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// Backend renamed `block` → `lock` and switched the verb from PATCH to PUT.
export const blockUserWithReason = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`admin/users/${id}/lock`, body)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// Backend uses PUT for freeze.
export const freezeUserAccount = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`admin/users/${id}/freeze`)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const restrictUserWithdrawal = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch(`admin/users/${id}/restrict-withdrawal`)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// ─── Per-user Crypto Withdraw Manager (admin-managed address whitelist) ──────
export const getWithdrawEnabledCoins = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/coins/enabled`, { params: { flow: "withdraw" } })
      .then((res) => resolve(encryptResponse(res.data)))
      .catch((e) => reject(e));
  });
};

export const getWithdrawCoinNetworks = (coinId) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/coins/${coinId}/networks`, { params: { flow: "withdraw" } })
      .then((res) => resolve(encryptResponse(res.data)))
      .catch((e) => reject(e));
  });
};

// Crypto Withdraw Manager — every change needs a single-use email OTP
// (send it first with sendCryptoWithdrawOtpApi, bound to the exact action).
export const sendCryptoWithdrawOtpApi = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/users/${id}/crypto-withdraw/send-otp`, body)
      .then((res) => resolve(encryptResponse(res.data)))
      .catch((e) => reject(e));
  });
};

export const toggleUserCryptoWithdraw = (id, enabled, otp) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch(`admin/users/${id}/crypto-withdraw`, { enabled, otp })
      .then((res) => resolve(encryptResponse(res.data)))
      .catch((e) => reject(e));
  });
};

export const addUserWithdrawAddress = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/users/${id}/crypto-withdraw/addresses`, { ...body, otp })
      .then((res) => resolve(encryptResponse(res.data)))
      .catch((e) => reject(e));
  });
};

export const toggleUserWithdrawAddress = (id, addressId, otp) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch(`admin/users/${id}/crypto-withdraw/addresses/${addressId}`, { otp })
      .then((res) => resolve(encryptResponse(res.data)))
      .catch((e) => reject(e));
  });
};

export const deleteUserWithdrawAddress = (id, addressId, otp) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`admin/users/${id}/crypto-withdraw/addresses/${addressId}`, { data: { otp } })
      .then((res) => resolve(encryptResponse(res.data)))
      .catch((e) => reject(e));
  });
};

export const adminDisable2FA = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`admin/users/${id}/2fa`)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const approveUserBank = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch(`admin/users/${id}/bank/approve`)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const rejectUserBank = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch(`admin/users/${id}/bank/reject`, body)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const triggerKycRedo = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/users/${id}/kyc/redo`, body || {})
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// KYC approve / reject — email OTP (sent to the admin inboxes) + reason. A decision can
// be changed later, so these work for approved and rejected users alike.
export const sendKycReviewOtp = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/users/${id}/kyc/review/send-otp`, body)
      .then((res) => resolve(encryptResponse(res.data)))
      .catch((e) => reject(e));
  });
};

export const resendKycReviewOtp = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/users/${id}/kyc/review/resend-otp`, body)
      .then((res) => resolve(encryptResponse(res.data)))
      .catch((e) => reject(e));
  });
};

export const decideKycReview = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/users/${id}/kyc/review/decision`, body)
      .then((res) => resolve(encryptResponse(res.data)))
      .catch((e) => reject(e));
  });
};

export const getKycReviewHistory = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/users/${id}/kyc/history`)
      .then((res) => resolve(encryptResponse(res.data)))
      .catch((e) => reject(e));
  });
};

export const getCoinList = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/coins`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// Coins
export const getCoin = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/coins`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getCoinById = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/coins/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const addCoin = (body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/coins`, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const editCoin = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`admin/coins/` + id, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const deleteCoin = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`admin/coins/` + id)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const patchCoinFlags = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch(`admin/coins/${id}/flags`, body)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};

export const updateCoinStatus = (id, status) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch(`admin/coins/${id}/status`, { status })
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};

// Fireblocks Sync admin endpoints
export const getFireblocksEnv = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/fireblocks/env`)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};
export const getFireblocksSupportedAssets = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/fireblocks/supported-assets`)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};
export const postFireblocksSyncMapping = (body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/fireblocks/sync-mapping`, body)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};

// Wallet tx review (Phase 4)
export const getWalletTxByIdV2 = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/wallet-tx/${id}`)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};
export const releaseWalletTx = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/wallet-tx/${id}/release`, body)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};
export const rejectWalletTx = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/wallet-tx/${id}/reject`, body)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};
export const manualDepositAction = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/wallet-tx/${id}/manual-deposit-action`, body)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};

// Compliance config (risk thresholds, blacklists)
export const listComplianceConfig = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/compliance-config`)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};
export const getRiskIndicatorCatalog = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/compliance-config/catalog`)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};
export const upsertComplianceConfig = (body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/compliance-config`, body)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};
export const deleteComplianceConfig = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`admin/compliance-config/${id}`)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};

// Maintenance mode (per-OS Android/iOS toggle, message + ETA)
export const getMaintenanceConfig = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/maintenance`)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};
export const upsertMaintenanceConfig = (body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/maintenance`, body)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};
export const getMaintenanceHistory = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/maintenance/history`, { params })
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};

// App version / force-update gate (per-OS)
export const getAppVersionConfig = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/app-version`)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};
export const upsertAppVersionConfig = (body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/app-version`, body)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};
export const getAppVersionHistory = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/app-version/history`, { params })
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};

// Screen-level (module-wise) maintenance (per screen × OS)
export const getScreenMaintenanceConfig = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/screen-maintenance`)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};
export const upsertScreenMaintenanceConfig = (body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/screen-maintenance`, body)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};
export const getScreenMaintenanceHistory = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/screen-maintenance/history`, { params })
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};

// Deposit / Withdrawal Feature Toggles
export const getFeatureToggleStatus = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`/user/feature-toggle/status`)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};
export const getFeatureToggles = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/feature-toggle`)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};
export const updateFeatureToggle = (body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/feature-toggle`, body)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};
export const getFeatureToggleHistory = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/feature-toggle/history`, { params })
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};

// KYC Configuration (deposit/withdrawal enable + cooling period)
export const getGlobalKycConfig = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/kyc-config/global`)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};
export const updateGlobalKycConfig = (body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/kyc-config/global`, body)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};
export const getUserKycConfig = (userId) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/kyc-config/user/${userId}`)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};
export const updateUserKycConfig = (userId, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/kyc-config/user/${userId}`, body)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};
export const getResolvedKycConfig = (userId) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/kyc-config/resolve/${userId}`)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};

//Category
export const getCategory = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/pair-categories`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
// Support
export const getSupport = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/support`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getSupportById = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/support/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const editSupport = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`admin/support/` + id, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const deleteSupport = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`admin/support/` + id)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// Bulk trade requests — off-platform USDT buy/sell desk. The list endpoint
// accepts the full filter set: page, sizePerPage, pagination, search, status,
// side (BUY/SELL), asset, userId, emailSent, minQuantity/maxQuantity,
// minPrice/maxPrice, minTotal/maxTotal, startDate, endDate, sortBy, sortOrder.
// Each row carries `userRequestCount` (lifetime requests by that user).
export const getAllBulkTradeRequests = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/bulk-trade-request`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getBulkTradeRequestById = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/bulk-trade-request/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const updateBulkTradeRequest = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`admin/bulk-trade-request/${id}`, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const deleteBulkTradeRequest = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`admin/bulk-trade-request/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// Currency (fiat)
// TODO(monorepo-migration): /admin/currency is not defined in the new
// admin-service. Verify whether the new backend exposes a replacement; this
// block likely needs to be removed or repointed.
export const getCurrency = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/currency`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getCurrencyById = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/currency/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const addCurrency = (body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/currency`, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const editCurrency = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`admin/currency/` + id, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const deleteCurrency = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`admin/currency/` + id)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// Trading Pair
export const getTradingPair = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/trading-pairs`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getTradingPairById = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/trading-pairs/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const addTradingPair = (body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/trading-pairs`, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const editTradingPair = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`admin/trading-pairs/` + id, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const cancelOpenOrders = (id, reason) =>
  request.post(`admin/trading-pairs/${id}/cancel-open-orders`, { reason }).then((r) => r.data);

export const toggleStopBuy = (id) =>
  request.put(`admin/trading-pairs/${id}/toggle-stop-buy`, {}).then((r) => r.data);

export const toggleStopSell = (id) =>
  request.put(`admin/trading-pairs/${id}/toggle-stop-sell`, {}).then((r) => r.data);

export const toggleStopAll = (id) =>
  request.put(`admin/trading-pairs/${id}/toggle-trading`, {}).then((r) => r.data);

export const toggleIsEnabled = (id) =>
  request.put(`admin/trading-pairs/${id}/toggle-enabled`, {}).then((r) => r.data);

export const toggleInternalization = (id) =>
  request.put(`admin/trading-pairs/${id}/toggle-internalization`, {}).then((r) => r.data);

export const deleteTradingPair = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`admin/trading-pairs/` + id)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const syncCoindcxPrecision = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/trading-pairs/sync-coindcx-precision`, {})
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// Custom Token Supply
export const allocateCoinSupply = (coinId, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/coins/${coinId}/allocate-supply`, body)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};

export const allocateCustomTokenSupply = (pairId, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/custom-tokens/${pairId}/allocate-supply`, body)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};

export const getCustomTokenAllocations = (pairId, params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/custom-tokens/${pairId}/allocations`, { params })
      .then((res) => resolve(res.data))
      .catch((e) => reject(e));
  });
};

// P2P
// TODO(monorepo-migration): /admin/P2PSupportCoin is not defined in the new
// admin-service. Verify whether the P2P module survived the rewrite.
export const getP2p = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/P2PSupportCoin`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getP2pById = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/P2PSupportCoin/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const addP2p = (body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/P2PSupportCoin`, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const editP2p = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`admin/P2PSupportCoin/` + id, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const deleteP2p = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`admin/P2PSupportCoin/` + id)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
// Payment method
// TODO(monorepo-migration): /admin/paymentMethod is not defined in the new
// admin-service. Verify whether this module is still in use.
export const getPaymentMethod = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/paymentMethod`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getPaymentMethodById = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/paymentMethod/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const addPaymentMethod = (body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/paymentMethod`, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const editPaymentMthod = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`admin/paymentMethod/` + id, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const deletePaymentMethod = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`admin/paymentMethod/` + id)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// ORDER method
export const getOrder = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/order-transactions`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getOrderCoinDcx = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/orders`, { params })
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};
// TODO(monorepo-migration): the new admin-service does not expose
// GET /admin/orders/:id (only /orders, /orders/by-user, /orders/:id/cancel).
// Verify whether callers actually need this or can use a different endpoint.
export const getOrderById = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/orders/${id}`)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// coin network — Backend-Monorepo's canonical path is /admin/coin-networks
// (kebab + plural). /admin/coinNetwork (camelCase) is preserved as a legacy
// alias in admin-service/admin.routes.ts, so existing calls keep working.
export const getCoinNetwork = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/coinNetwork`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const addCoinNetwork = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/coinNetwork`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const updateCoinNetwork = (data, id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`admin/coinNetwork/${id}`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getCoinNetworkById = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/coinNetwork/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const deletCoinNetworkById = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`admin/coinNetwork/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
// Withdrawal
export const getWithdrawalReq = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/coinbuysell/withdrawal`, { params })
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};
// INR deposit/withdraw counts (from coin_withdrawal) for the user-overview
// stat cards. Returns { depositCount, withdrawCount }.
export const getInrTransactionCounts = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/coinbuysell/withdrawal-counts`, { params })
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getWithdrawalStatus = (id, params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`admin/coinbuysell/withdrawal/${id}`, params)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// Sends an OTP to the admin inboxes before approving (ACCEPT) or rejecting (REJECT) a DEPOSIT.
export const sendDepositApprovalOtpApi = (id, action = "ACCEPT") => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/coinbuysell/withdrawal/${id}/send-approval-otp`, { action })
      .then((res) => resolve(encryptResponse(res.data)))
      .catch((e) => reject(e));
  });
};

// Resends a fresh OTP to the acting admin's email.
export const resendDepositApprovalOtpApi = (id, action = "ACCEPT") => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/coinbuysell/withdrawal/${id}/resend-approval-otp`, { action })
      .then((res) => resolve(encryptResponse(res.data)))
      .catch((e) => reject(e));
  });
};

// Withdrawal approve/reject OTP: emailed to the admin inboxes, bound to the
// action ("ACCEPT" | "REJECT") it was requested for.
export const sendWithdrawalApprovalOtpApi = (id, action) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/coinbuysell/withdrawal/${id}/send-approval-otp`, { action })
      .then((res) => resolve(encryptResponse(res.data)))
      .catch((e) => reject(e));
  });
};

export const resendWithdrawalApprovalOtpApi = (id, action) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/coinbuysell/withdrawal/${id}/resend-approval-otp`, { action })
      .then((res) => resolve(encryptResponse(res.data)))
      .catch((e) => reject(e));
  });
};

// Admin creates a deposit (credit note) on behalf of a user.
// formData must be a FormData instance with: userId, coinId, amount, utrNumber, remarks?, paymentProof?
export const createAdminDepositApi = (formData) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/coinbuysell/withdrawal`, formData)
      .then((res) => resolve(encryptResponse(res.data)))
      .catch((e) => reject(e));
  });
};

// Admin edits a PENDING deposit record.
// formData must be a FormData instance with any of: amount, utrNumber, remarks, paymentProof?
export const updateDepositDetailsApi = (id, formData) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch(`admin/coinbuysell/withdrawal/${id}`, formData)
      .then((res) => resolve(encryptResponse(res.data)))
      .catch((e) => reject(e));
  });
};

// Marks a PENDING deposit as Action Required — keeps the request open so the
// user can re-upload proof instead of rejecting outright. body: { reason, remarks? }
export const markDepositActionRequiredApi = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch(`admin/coinbuysell/withdrawal/${id}/action-required`, body)
      .then((res) => resolve(encryptResponse(res.data)))
      .catch((e) => reject(e));
  });
};

export const getFaq = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`/admin/home-faq/all`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const addFaq = (body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`/admin/home-faq/add`, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const editFaq = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`/admin/home-faq/update/` + id, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const deleteFaq = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`/admin/home-faq/delete/` + id)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const getPolicyLinks = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`/admin/policy-link`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const updatePolicyLink = (body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`/admin/policy-link`, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const getNewsletter = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`/admin/news-letter`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const deleteNewsletter = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`/admin/news-letter/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getContacts = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`/admin/contact-us`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const deleteContact = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`/admin/contact-us/` + id)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const addEdd = (id, data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`/admin/user/edd/${id}`, data)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const updateEdd = (id, data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`/admin/user/edd/${id}`, data)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getUserWalletTrx = (params) => {
  const url = !params?.userId
    ? `admin/user-wallet/transaction/nouser`
    : `admin/user-wallet/transaction/${params?.userId}`;

  delete params.userId;

  return new Promise(async (resolve, reject) => {
    await request
      .get(url, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getUserWalletTrxById = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(
        `admin/user-wallet/transaction/nouser?transactionId=${params}`,
        params
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// Third Party Stats
export const getThirdPartyStats = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/user/third-party-stats`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// Service Status
export const getServiceStatus = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/user/service-status`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// Gullak Plans
export const getGullakPlans = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`/admin/gullak/plans`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const addGullakPlan = (body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`/admin/gullak/plans`, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const editGullakPlan = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`/admin/gullak/plans/${id}`, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const deleteGullakPlan = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`/admin/gullak/plans/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// Balance Comparison
// TODO(monorepo-migration): /admin/coindcx/* is not yet exposed by the new
// admin-service. Re-verify path once the backend adds these endpoints.
export const getBalanceComparison = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`/admin/coindcx/balance-comparison`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// CoinDCX Order History
export const getCoinDcxOrderHistory = (params = {}) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`/admin/coindcx/orders/history`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// CoinDCX Order by ID
export const getCoinDcxOrderById = (orderId) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`/admin/coindcx/orders/${orderId}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const cancelAdminOrder = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch(`admin/orders/${id}/cancel`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const reconcileOrders = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`/admin/coindcx/reconcile`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// Role Management
export const getRoles = (params = {}) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get("admin/role", { params })
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const getRoleById = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/role/${id}`)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const addRole = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post("admin/role", data)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const editRole = (id, data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`admin/role/${id}`, data)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const deleteRole = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`admin/role/${id}`)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const getPermissionModules = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get("admin/role/modules")
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const assignRoleToUser = (userId, data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`admin/role/assign/${userId}`, data)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// Admin User Management
export const getAdminUsers = (params = {}) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get("admin/admin-users", { params })
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const getAdminUserById = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/admin-users/${id}`)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const createAdminUser = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post("admin/admin-users", data)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const updateAdminUser = (id, data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`admin/admin-users/${id}`, data)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const deleteAdminUserApi = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`admin/admin-users/${id}`)
      .then((res) => {
        resolve(encryptResponse(res.data));
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// Logs (CloudWatch Logs Insights)
export const getLogsApi = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/logs`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e?.response || e);
      });
  });
};

export const getLogActionsApi = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/logs/actions`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e?.response || e);
      });
  });
};

// User Activity Log — unified per-user fund-flow timeline (INR deposit/
// withdrawal lifecycle, funding<->spot transfers, buy/sell trades), backed
// by the wallet_ledgers audit trail. See admin-service's
// user-activity-log.controller.ts for the full field/filter reference.
export const getUserActivityLogApi = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/user-activity-log`, { params })
      .then((res) => resolve(res.data))
      .catch((e) => reject(e?.response || e));
  });
};

export const getUserActivityLogFilterOptionsApi = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/user-activity-log/filter-options`)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e?.response || e));
  });
};

export const exportUserActivityLogApi = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/user-activity-log/export`, { params, responseType: "blob" })
      .then((res) => resolve(res))
      .catch((e) => reject(e?.response || e));
  });
};

// Manual Wallet Adjustment — admin credits/debits a user's FUNDING wallet for
// any coin (reason + emailed single-use OTP required). Backend uses sendSuccess
// (AES encrypted).
export const manualWalletAdjustmentApi = ({ userId, coinId, type, amount, reason, otp }) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/wallet/manual-adjustment`, { userId, coinId, type, amount, reason, otp })
      .then((res) => resolve(encryptResponse(res.data)))
      .catch((e) => reject(e?.response || e));
  });
};

// Emails the OTP (to the admin inboxes) that confirms exactly this adjustment.
// Valid 60s, single use. Same body as the adjustment, without the otp.
export const sendWalletAdjustmentOtpApi = ({ userId, coinId, type, amount, reason }) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/wallet/manual-adjustment/send-otp`, { userId, coinId, type, amount, reason })
      .then((res) => resolve(encryptResponse(res.data)))
      .catch((e) => reject(e?.response || e));
  });
};

// History for the tab's bottom table — reuses the existing ledger
// incident-response tool, scoped to this user's manual adjustments.
// GET /admin/ledger responds via sendPaginated (AES encrypted), same as
// sendSuccess — decrypt with encryptResponse before use.
export const getWalletAdjustmentHistoryApi = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/ledger`, { params: { referenceType: "ADMIN_ADJUSTMENT", walletType: "FUNDING", ...params } })
      .then((res) => resolve(encryptResponse(res.data)))
      .catch((e) => reject(e?.response || e));
  });
};

// TODO(monorepo-migration): same as getUserWalletByType — /admin/wallet has
// no replacement. Likely needs to be removed or repointed at the new
// per-user spot/funding balance endpoints.
export const getUsersByCoinIdAndWalletType = (coinId, walletType, params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/wallet`, { params: { ...params, coinId, walletType } })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// ============================================================
// Finance Dashboard (Section 5)
// ============================================================

// 5.1 Fee & Revenue Analytics
export const getFinanceOverviewApi = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/finance/overview`, { params })
      .then((res) => resolve(res.data))
      .catch((e) => reject(e?.response || e));
  });
};

export const getFinanceTimeseriesApi = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/finance/overview/timeseries`, { params })
      .then((res) => resolve(res.data))
      .catch((e) => reject(e?.response || e));
  });
};

export const getFinanceOverviewTableApi = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/finance/overview/table`, { params })
      .then((res) => resolve(res.data))
      .catch((e) => reject(e?.response || e));
  });
};

export const exportFinanceOverviewCsvApi = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/finance/overview/export`, { params, responseType: "blob" })
      .then((res) => resolve(res))
      .catch((e) => reject(e?.response || e));
  });
};

// 5.2 Crypto Withdrawal Fees
export const getWithdrawalFeesApi = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/finance/withdrawal-fees`, { params })
      .then((res) => resolve(res.data))
      .catch((e) => reject(e?.response || e));
  });
};

export const exportWithdrawalFeesCsvApi = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/finance/withdrawal-fees/export`, { params, responseType: "blob" })
      .then((res) => resolve(res))
      .catch((e) => reject(e?.response || e));
  });
};

export const uploadWithdrawalExpenseApi = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`admin/finance/withdrawal-fees/upload`, data)
      .then((res) => resolve(res.data))
      .catch((e) => reject(e?.response || e));
  });
};

export const listWithdrawalExpenseUploadsApi = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/finance/withdrawal-fees/uploads`, { params })
      .then((res) => resolve(res.data))
      .catch((e) => reject(e?.response || e));
  });
};

// 5.3 TDS Reports
export const getTdsMonthlyApi = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/finance/tds/monthly`, { params })
      .then((res) => resolve(res.data))
      .catch((e) => reject(e?.response || e));
  });
};

export const exportTdsAnnualSummaryApi = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/finance/tds/monthly/export`, { params, responseType: "blob" })
      .then((res) => resolve(res))
      .catch((e) => reject(e?.response || e));
  });
};

export const downloadTdsMonthlyDetailApi = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/finance/tds/monthly/download`, { params, responseType: "blob" })
      .then((res) => resolve(res))
      .catch((e) => reject(e?.response || e));
  });
};

// Per-user TDS breakdown for a given year.
// Supported params: year (required), month (1-12), page, sizePerPage, search
export const getTdsUsersApi = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/finance/tds/users`, { params })
      .then((res) => resolve(res.data))
      .catch((e) => reject(e?.response || e));
  });
};

export const exportTdsUsersApi = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/finance/tds/users/export`, { params, responseType: "blob" })
      .then((res) => resolve(res))
      .catch((e) => reject(e?.response || e));
  });
};

// 5.5 INR Deposits
export const getInrDepositsApi = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/finance/inr-deposits`, { params })
      .then((res) => resolve(res.data))
      .catch((e) => reject(e?.response || e));
  });
};

export const exportInrDepositsCsvApi = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/finance/inr-deposits/export`, { params, responseType: "blob" })
      .then((res) => resolve(res))
      .catch((e) => reject(e?.response || e));
  });
};

// 5.6 INR Withdrawals
export const getInrWithdrawalsApi = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/finance/inr-withdrawals`, { params })
      .then((res) => resolve(res.data))
      .catch((e) => reject(e?.response || e));
  });
};

export const exportInrWithdrawalsCsvApi = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/finance/inr-withdrawals/export`, { params, responseType: "blob" })
      .then((res) => resolve(res))
      .catch((e) => reject(e?.response || e));
  });
};

// 5.7 Funding Wallet Transactions
export const getFundingWalletTransactionsApi = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/funding-wallet-transactions`, { params })
      .then((res) => resolve(res.data))
      .catch((e) => reject(e?.response || e));
  });
};

export const exportFundingWalletTransactionsCsvApi = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/funding-wallet-transactions/export`, {
        params,
        responseType: "blob",
      })
      .then((res) => resolve(res))
      .catch((e) => reject(e?.response || e));
  });
};

// FIU / VASP Monthly Reports
export const getFiuMonthlySummaryApi = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/vasp-report/monthly-summary`, { params })
      .then((res) => resolve(res.data))
      .catch((e) => reject(e?.response || e));
  });
};

export const exportFiuMonthlyReportApi = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/vasp-report/export`, { params, responseType: "blob" })
      .then((res) => resolve(res))
      .catch((e) => reject(e?.response || e));
  });
};

// Affiliate Codes
export const getAffiliateCodes = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get("admin/affiliate", { params })
      .then((res) => resolve(encryptResponse(res.data)))
      .catch((e) => reject(e?.response || e));
  });
};

export const getAffiliateCodeById = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/affiliate/${id}`)
      .then((res) => resolve(encryptResponse(res.data)))
      .catch((e) => reject(e?.response || e));
  });
};

export const addAffiliateCode = (body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post("admin/affiliate", body)
      .then((res) => resolve(encryptResponse(res.data)))
      .catch((e) => reject(e?.response || e));
  });
};

export const editAffiliateCode = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`admin/affiliate/${id}`, body)
      .then((res) => resolve(encryptResponse(res.data)))
      .catch((e) => reject(e?.response || e));
  });
};

export const deleteAffiliateCode = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`admin/affiliate/${id}`)
      .then((res) => resolve(encryptResponse(res.data)))
      .catch((e) => reject(e?.response || e));
  });
};
